module.exports = __webpack_public_path__ + "img/main1.30f0a23a.jpg";